import { COMMERCIAL, PERSONAL } from "../../../constants/keys";
import styles from "./ButtonToggle.module.css";

function ButtonToggle({ handleSelect, selected }) {
  return (
    <div className={styles.container}>
      <button
        className={`noselect ${styles.toggleBase} ${styles.leftButton} ${
          selected === PERSONAL && styles.selected
        }`}
        onClick={() => handleSelect(PERSONAL)}
      >
        PERSONAL
      </button>
      <button
        className={`noselect ${styles.toggleBase} ${styles.rightButton} ${
          selected === COMMERCIAL && styles.selected
        }`}
        onClick={() => handleSelect(COMMERCIAL)}
      >
        COMMERCIAL
      </button>
    </div>
  );
}

export default ButtonToggle;
